@if (chartId) {
  <div class="h-[400px] px-[30px] bg-surface-background rounded-[16px] border border-textbox-border">
    <div class="flex flex-col flex-nowrap items-center pb-[37px] pt-[21px]">
      <div class="max-w-full font-spaceGrotesk font-medium text-[18px] whitespace-nowrap overflow-y-hidden overflow-x-auto scrollbar-thin scrollbar-thumb-neutral">{{ chart.title }}</div>
      <div class="max-w-full inter-300 text-[14px] text-support-text whitespace-nowrap overflow-y-hidden overflow-x-auto scrollbar-thin scrollbar-thumb-neutral">{{ chart.subtitle }}</div>
    </div>
    <canvas class="max-h-[240px] text-inverted-neutral" [id]="chartId"></canvas>
  </div>
}